import React, { useContext, useState } from "react";
import { HeaderMasterDropdown } from "./HeaderMasterDropdown";
import SubmenuHeader from "./SubmenuHeader";

import {
  Bars2Icon,
  HomeIcon,
  MoonIcon,
  PowerIcon,
  SunIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Link, useNavigate } from "react-router-dom";
import { UserContext } from "./Context/UserContext";
import { toast } from "react-hot-toast";
import { confirmAlert } from "react-confirm-alert";
import ClickOutHandler from "react-clickout-handler";

import Vazron_Logo from "../../src/assets/vazron_logo.png";
import { SmallDeviceHeaderMasterDropdown } from "./SmallDeviceHeaderMasterDropdown";

export default function HeaderLayout() {
  const {
    darkTheme,
    setDarkTheme,
    isHeaderMenuOpen,
    setIsHeaderMenuOpen,
    loginData,
    setLoginData,
    setSelectedMenu,
    selectedMenu,
  } = useContext(UserContext);
  // const [selectedMenu, setSelectedMenu] = useState(null);

  const navigate = useNavigate();

  // CONFIRM ALERT FOR DELETE A RECORD=================
  function LogoutFun() {
    const options = {
      // title: "Are you sure?",
      message: "You want to logout?",
      buttons: [
        {
          label: "Yes",
          onClick: () => logoutConfirm(),
        },
        {
          label: "No",
          // onClick: () => alert('Click No')
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      willUnmount: () => {},
      afterClose: () => {},
      onClickOutside: () => {},
      onKeypress: () => {},
      onKeypressEscape: () => {},
      overlayClassName: "overlay-custom-class-name",
    };
    async function logoutConfirm() {
      await fetch("https://erp.vazron.in/api/logout", {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${loginData.token}`,
        },
      })
        .then((resjson) => resjson.json())
        .then((deleteRes) => {
          // console.log("deleteRes", deleteRes)
          if (deleteRes.status) {
            localStorage.removeItem("vazronLoginData");
            setLoginData({});
            toast.success("Logout!");
            navigate("/");
          }
        });
    }
    confirmAlert(options);
  }

  const handleHomeKeyEnter =(e)=>{
    if(e.keyCode === 13){
      setSelectedMenu(null)
    }
  }
  return (
    <div className="sticky z-40 top-0 left-0 right-0 h-8 bg-red-900 flex items-center px-4">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center">
          {/* home icon  */}
          <Link
            to={"/"}
            className={`no-underline transition-all active:bg-gray-100 rounded-full p-[2px] hover:bg-gray-400 hideHeader`}
            onClick={()=> setSelectedMenu(null)}
            onKeyDown={(e)=> handleHomeKeyEnter(e)}
          >
            <HomeIcon
              className={`w-5 h-5 ${
                darkTheme ? "text-slate-50" : "text-slate-50"
              }`}
            />
          </Link>
          {/* home icon close  */}

          {/* MENU COMPONENT  */}
          <div className="hideHeader">
            <HeaderMasterDropdown
              selectedMenu={selectedMenu}
              setSelectedMenu={setSelectedMenu}
            />
          </div>
          {/* SMALL DIVICES ---HEADER-MENU-DROPDOWN============ */}
          <div className="hidden showHeader">
            <div className="flex items-center gap-5">
              <div>
                <ClickOutHandler onClickOut={() => setIsHeaderMenuOpen(false)}>
                  <div
                    className=""
                    onClick={() => setIsHeaderMenuOpen(!isHeaderMenuOpen)}
                  >
                    {isHeaderMenuOpen ? (
                      <XMarkIcon
                        className={`w-5 h-5 ${
                          darkTheme ? "text-slate-50" : "text-slate-50"
                        }`}
                      />
                    ) : (
                      <Bars2Icon
                        className={`w-5 h-5 ${
                          darkTheme ? "text-slate-50" : "text-slate-50"
                        }`}
                      />
                    )}
                  </div>
                  {isHeaderMenuOpen && (
                    <div className="bg-[#ca96c8] absolute z-40 top-8 w-60 max-w-72 border-2 left-2 p-2 rounded-md border-[#b889b6]">
                      <div className="flex flex-col gap-1">
                        {/* <MasterMenu />
                        <PurchaseMenu /> */}

                        {/* <MaterialManagementMenu /> */}
                        {/* <SalesMenu /> */}
                        {/* <FleetMenu /> */}
                        {/* <AccountsMenu />
                        <CompanyProfileMenu />
                        <ServiceCenterMenu /> */}

                        <SmallDeviceHeaderMasterDropdown
                          selectedMenu={selectedMenu}
                          setSelectedMenu={setSelectedMenu}
                        />
                      </div>
                    </div>
                  )}
                </ClickOutHandler>
              </div>

              <div className="hidden showHeader">
                <Link to={"/"}>
                  <img
                    src={Vazron_Logo}
                    alt="vazron_logo"
                    className="w-20 logoInvert"
                  />
                </Link>
              </div>
            </div>
          </div>
          {/* CLOSE SMALL DIVICES HEADER ====== */}

          {/* SUBMENU COMPONENT  */}
          {/* <SubmenuHeader selectedMenu={selectedMenu} /> */}
        </div>

        <button
          className={`p-[2px] rounded-full text-sm transition-all active:bg-gray-50 hover:bg-red-400 text-white flex items-center justify-center`}
          onClick={() => LogoutFun()}
        >
          <PowerIcon className="w-5 h-5 font-[600]" />
        </button>
      </div>
    </div>
  );
}
